import {useEffect, useRef} from "preact/hooks";
import Cookies from "js-cookie";
import store from "store2";
export default function Index() {
    const pathRef = useRef('/')
    useEffect(() => {
        const thirdPartLogin = Cookies.get('thirdPartLogin');
        function clearAllCookie() {
            var keys = document.cookie.match(/[^ =;]+(?=\=)/g);
            if(keys) {
                for(var i = keys.length; i--;)
                    document.cookie = keys[i] + '=0;path=/;expires=' + new Date(0).toUTCString()
            }
        }

        if (thirdPartLogin) {
            const path = Cookies.get('origin_url');
            if (path) {
                pathRef.current = path;
            }
        }

        clearAllCookie();

        store.clearAll();

        location.href = pathRef.current;
    }, [])

    return (
        <div>

        </div>
    )
}

